import { ICostSummaryItem, ILineItem } from '../CartContext.types';
import { usePlanPaymentHook } from './Plan/PlanPaymentHook';
import { useAutopayDiscountHook } from './Plan/AutopayDiscountHook';
import { useCustomerDiscountHook } from './Plan/CustomerDiscountHook';

export const generatePlanCosts = (
    lineItem: ILineItem,
    hasAutopay: boolean,
    summaryList: ICostSummaryItem[]
) => {
    summaryList.push(usePlanPaymentHook(lineItem));

    const discount = lineItem.planSelection?.customerAppreciationDiscount;

    if (hasAutopay) {
        const autoPayDiscount = useAutopayDiscountHook(lineItem, discount);
        if (autoPayDiscount) {
            summaryList.push(autoPayDiscount);
        }
    }

    const customerDiscount = useCustomerDiscountHook(lineItem, discount);
    if (customerDiscount) {
        summaryList.push(customerDiscount);
    }
};
